import * as React from "react";
import styled from "styled-components";
import { InputGroup } from "components/bootstrap";
const TableInfo = styled(InputGroup.Addon)`
  width: auto;
  text-align: left;
  cursor: not-allowed;
`;
const LookupTableParameterPreview = ({ parameter: { key, lookupTable } }) => /* @__PURE__ */ React.createElement(TableInfo, null, "Lookup Table: ", lookupTable, " \u2013 ", key);
export default LookupTableParameterPreview;
